import React from 'react';
import { Dialog, DialogContent } from '@/components/ui/dialog';
import { X } from 'lucide-react';

interface YouTubeModalProps {
  isOpen: boolean;
  onClose: () => void;
  videoId: string;
  title?: string;
}

const YouTubeModal: React.FC<YouTubeModalProps> = ({ 
  isOpen, 
  onClose, 
  videoId, 
  title = "Video" 
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="max-w-6xl w-[95vw] h-auto max-h-[70vh] sm:max-h-[90vh] md:w-full md:h-full p-0 border-0 bg-black">
        <div className="relative h-full">
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-50 rounded-full bg-black/70 p-3 text-white hover:bg-black/90 transition-colors"
            aria-label="Close video"
          >
            <X size={24} />
          </button>
          
          <div className="w-full h-full aspect-video">
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&iv_load_policy=3`}
              title={title}
              allow="autoplay; encrypted-media; fullscreen"
              allowFullScreen
              className="w-full h-full"
              style={{ border: 'none' }}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default YouTubeModal;